<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
      v-if="!isTrumbowygFullscreen"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up white--text"></v-toolbar-side-icon>
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ productId ? 'Edit ' + productId : 'Add Product' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list v-if="productId">
          <v-list-tile @click.stop="openDeleteProductDialog();">
            <v-list-tile-title>Delete</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list v-else>
          <v-list-tile @click.stop="openImportProductDialog();">
            <v-list-tile-title>Import Product</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          layout
          align-content-start
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-btn
              block
              large
              outline
              v-if="productId"
              :href="def.marketplaceDomain + '/' + permalink + '.html'"
              target="_blank"
            >
              View product page
            </v-btn>

            <div class="text-xs-right" v-if="erp && erp.integrations && erp.integrations.length > 0">
              <div v-if="erp.sellerErpErrorCount && erp.sellerErpErrorCount > 0">
                <div v-if="erp.sellerErpLastAttemptDateTime && erp.sellerErpLastAttemptDateTime !== ''">
                  ERP Sync Failed on {{ erp.sellerErpLastAttemptDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                  <v-btn
                    outline
                    round
                    small
                    @click="dialogViewErpSyncDetails = true"
                  >View</v-btn>
                  <v-btn
                    outline
                    round
                    small
                    @click="dialogConfirmResyncProductToErp = true"
                  >Resync</v-btn>
                </div>
                <div v-if="erp.sellerErpErrorMsg && erp.sellerErpErrorMsg !== ''" class="caption red--text">
                  {{ erp.sellerErpErrorMsg }}
                </div>
              </div>
              <div v-else-if="erp && erp.createdInSellerErpDateTime && erp.createdInSellerErpDateTime !== ''">
                Synced to ERP on {{ erp.createdInSellerErpDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                <v-btn
                  v-if="erp && erp.sellerErpLastAttemptRequest && erp.sellerErpLastAttemptRequest != ''"
                  outline
                  round
                  small
                  @click="dialogViewErpSyncDetails = true"
                >View</v-btn>
                <v-btn
                  outline
                  round
                  small
                  @click="dialogConfirmResyncProductToErp = true"
                >Resync</v-btn>
              </div>
              <div v-else>
                Pending for Sync
              </div>
            </div>

            <v-container grid-list-sm>
              <p class="subheading text-xs-left">Product Images</p>
              <v-layout row wrap>
                <v-flex xs12 style="overflow-x:auto;">
                  <Container @drop="onDropImage" orientation="horizontal" behaviour="contain">
                    <Draggable v-for="item in images" :key="item.productImageId">
                      <v-card flat class="transparent ma-1 pa-2" style="width:150px;border:1px solid #ababab !important;">
                        <v-img :src="item.smallUrl" aspect-ratio="1.2"></v-img>
                        <v-text-field
                          v-if="copyProductId && copyProductId.length > 0"
                          v-model="item.description"
                          :counter="100"
                        ></v-text-field>
                        <v-text-field
                          v-else
                          :value="item.description"
                          readonly
                        ></v-text-field>
                        <v-card-actions class="pa-0">
                          <v-container fluid grid-list-md fill-height pa-0>
                            <v-layout>
                              <v-flex xs12 text-xs-right flexbox>
                                <span class="group">
                                  <!--<v-btn outline small v-if="item.isPrimary !== 1" @click.stop="openPrimaryImageDialog(item.productImageId)">
                                    Set Primary
                                  </v-btn>-->
                                  <v-btn icon small @click.stop="openDeleteImageDialog(item.productImageId)">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-actions>
                      </v-card>
                    </Draggable>
                  </Container>
                </v-flex>
                <v-flex
                  v-if="images.length <= 35 && !(copyProductId && copyProductId.length > 0)"
                  xs3
                >
                  <v-card flat style="background-color:transparent;">
                    <v-btn outline large fab color="primary" @click="resetImageForm(); dialogAddImage=true;">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container grid-list-sm>
              <p class="subheading text-xs-left">Product Videos</p>
              <v-layout row wrap>
                <v-flex xs12 style="overflow-x:auto;">
                  <Container @drop="onDropVideo" orientation="horizontal" behaviour="contain">
                    <Draggable v-for="item in videos" :key="item.videoId">
                      <v-card flat class="transparent ma-1 pa-2" style="width:300px;border:1px solid #ababab !important;">
                        <a :href="item.videoUrl" target="_blank"><v-img :src="item.mediumUrl" aspect-ratio="1.2"></v-img></a>
                        <v-text-field
                          v-model="item.description"
                          :counter="255"
                        ></v-text-field>
                        <v-card-actions class="pa-0">
                          <v-container fluid grid-list-md fill-height pa-0>
                            <v-layout>
                              <v-flex xs12 text-xs-right flexbox>
                                <span class="group">
                                  <v-btn icon small @click.stop="openDeleteVideoDialog(item.videoPlatformId, item.videoId)">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-actions>
                      </v-card>
                    </Draggable>
                  </Container>
                </v-flex>
                <v-flex
                  v-if="videos.length <= 5 && !(copyProductId && copyProductId.length > 0)"
                  xs3
                >
                  <v-btn outline large fab color="primary" @click="openAddVideoDialog">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>

            <v-text-field
              v-model="txtName"
              :rules="[v => !!v || 'Product name is required', v => (v && v.length > 3) || 'Name must be 3 characters or more']"
              :counter="250"
              label="Name"
              required
              :append-icon="'wb_incandescent'"
              @click:append="showAiForName = !showAiForName"
            ></v-text-field>
            <v-card v-if="showAiForName" class="mb-3">
              <v-card-text v-if="generatingAiForName" class="pl-3">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :width=4
                  class="mb-0 mr-3"
                ></v-progress-circular>
                Generating ...
              </v-card-text>
              <v-card-text v-else>
                <div class="pa-2 font-italic">{{ aiName }}</div>
                <div>
                  <v-btn
                    outline
                    small
                    @click="txtName = aiName; showAiForName = false;"
                  >
                    Apply
                  </v-btn>
                  <v-btn
                    outline
                    small
                    @click="generateAiName(txtName)"
                  >
                    Regenerate
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
            <v-text-field
              v-model="txtKeywords"
              :counter="250"
              label="Keywords"
            ></v-text-field>
            <v-text-field
              v-model="txtAlternativeKeywords"
              :counter="250"
              label="Show alternative products with these keywords (separate by coma)"
            ></v-text-field>
            <category-dropdown v-model="cboCategory" label="Category"></category-dropdown>
            <category-dropdown v-model="cboSecondaryCategory" label="Secondary Category" blank></category-dropdown>
            <v-switch
              v-model="switchContainLiquid"
              label="Contain Liquid"
              color="primary"
            ></v-switch>
            <v-switch
              v-model="switchContainPaste"
              label="Contain Paste"
              color="primary"
            ></v-switch>
            <v-switch
              v-model="switchContainBattery"
              label="Contain Battery"
              color="primary"
            ></v-switch>
            <v-combobox
              v-model="cboUnavailableCountries"
              :items="countries"
              item-text="countryName"
              item-value="countryId"
              label="Unavailable for Countries"
              hide-details
              chips
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  @input="removeUnavailableCountry(data.item)"
                >
                  <strong>{{ data.item.countryName }}</strong>
                </v-chip>
              </template>
            </v-combobox>
            <v-select
              v-model="cboStatus"
              :items="statuses"
              item-text="caption"
              item-value="value"
              :rules="[v => !!v || 'Please select a status']"
              label="Status"
              required
            ></v-select>
            <v-text-field
              v-model="txtMetaDescription"
              :counter="160"
              label="Meta Description"
            ></v-text-field>
            <trumbowyg id="trumbowyg" v-model="txtDescription" :config="trumbowygConfig"></trumbowyg>
            <div v-if="!showAiForDescription">
              <v-btn
                icon
                @click="showAiForDescription = !showAiForDescription"
              >
                <v-icon>wb_incandescent</v-icon>
              </v-btn>
            </div>
            <v-card v-else class="mb-3">
              <v-card-text v-if="generatingAiForDescription" class="pl-3">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :width=4
                  class="mb-0 mr-3"
                ></v-progress-circular>
                Generating ...
              </v-card-text>
              <v-card-text v-else>
                <div class="text-xs-right">
                  <v-btn icon @click="showAiForDescription = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <div class="pa-2 font-italic" v-html="aiDescription"></div>
                <div>
                  <v-btn
                    outline
                    small
                    @click="txtDescription = aiDescription; showAiForDescription = false;"
                  >
                    Apply
                  </v-btn>
                  <v-btn
                    outline
                    small
                    @click="generateAiDescription(txtDescription)"
                  >
                    Regenerate
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>

            <!--
            <v-textarea
              :rules="[v => !!v || 'Product description is required', v => (v && v.length > 10) || 'Description must be 10 characters or more']"
              label="Description"
              required
            ></v-textarea>
            -->
            <v-container grid-list-lg>
              <v-layout fluid wrap>
                <v-flex xs12>
                  <h4 class="text-xs-left title font-weight-bold mb-3">Extra Params</h4>
                  <v-card>
                    <v-container>
                      <v-layout fluid wrap v-for="(item, index) in productParams" :key="index">
                        <v-flex xs6 md3 class="body-2 font-weight-bold">
                          <v-text-field
                            v-model="item.name"
                            label="Name"
                            :rules="[v => !!v || 'Name is required']"
                            prepend-icon="cancel"
                            @click:prepend="removeParam(index)"
                            :counter=15
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md2 class="body-2 font-weight-bold">
                          <v-select
                            v-model="item.type"
                            :items="paramTypes"
                            item-text="caption"
                            item-value="type"
                            :rules="[v => !!v || 'Please select type']"
                            label="Type"
                            required
                            @change="initParamInput(item.type, index)"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md7 class="body-2 font-weight-bold">
                          <v-text-field
                            v-model="item.desc"
                            label="Short description"
                            :counter=40
                          ></v-text-field>
                        </v-flex>
                        <v-flex offset-xs1 xs11>
                          <v-card>
                            <v-container v-if="item.type === 'text' && item.param">
                              <v-layout fluid wrap>
                                <v-flex xs4 class="body-2 font-weight-bold">
                                  <v-text-field
                                    v-model="item.param.minLength"
                                    :rules="[v => /^[-|+]?\d*$/.test(v) || 'Min length must be integer']"
                                    label="Min Digit"
                                    type="number"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4 class="body-2 font-weight-bold">
                                  <v-text-field
                                    v-model="item.param.maxLength"
                                    :rules="[v => /^[-|+]?\d*$/.test(v) || 'Max length must be integer']"
                                    label="Max Digit"
                                    type="number"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6 class="body-2 font-weight-bold">
                                  <v-select
                                    v-model="item.param.validationType"
                                    :items="paramTextTypes"
                                    item-text="caption"
                                    item-value="type"
                                    :rules="[v => !!v || 'Please select type']"
                                    label="Type"
                                    required
                                  ></v-select>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container v-else-if="item.type === 'select' && item.param">
                              <v-layout fluid wrap>
                                <v-flex xs12 sm6 class="body-2 font-weight-bold">
                                  <v-select
                                    v-model="item.param.isMultipleSelection"
                                    :items="multipleSelection"
                                    item-text="caption"
                                    item-value="value"
                                    required
                                  ></v-select>
                                </v-flex>
                                <v-flex xs12 class="body-2 font-weight-bold">
                                  <v-container class="pa-0">
                                    <v-layout fluid wrap v-for="(selectItem, selectItemIndex) in item.param.items" :key="selectItemIndex" class="mt-5">
                                      <v-flex xs6 sm2>
                                        <v-img v-if="selectItem.productImageId" :src="selectItem.imageSmallUrl" aspect-ratio="1.2"></v-img>
                                        <div v-else style="width:100%; height:120px; border:1px solid #ababab; padding:35px 10px;text-align: center">No Image</div>
                                        <div class="text-xs-center">
                                          <v-btn
                                            outline
                                            small
                                            block
                                            @click="openSelectImageDialog(null, index, selectItemIndex)"
                                          >
                                            Select Image
                                          </v-btn>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 sm6 class="body-2 font-weight-bold">
                                        <v-text-field
                                          v-model="selectItem.name"
                                          label="Name"
                                          :rules="[v => !!v || 'Name is required']"
                                          prepend-icon="cancel"
                                          @click:prepend="removeParamItem(index, selectItemIndex)"
                                          :counter=100
                                          required
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs8 sm2 class="body-2 font-weight-bold">
                                        <v-text-field
                                          v-model="selectItem.price"
                                          label="Price"
                                          :prefix="currencySign"
                                          type="number"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs4 sm2 class="body-2 font-weight-bold">
                                        <v-text-field
                                          v-model="selectItem.weight"
                                          label="Weight"
                                          suffix="kg"
                                          type="number"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout fluid wrap>
                                      <v-flex xs12 class="body-2 font-weight-bold text-xs-right">
                                        <v-btn
                                          outline
                                          @click="addParamItem(index)"
                                        >
                                          <v-icon>add</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container v-else-if="item.type === 'file' && item.param">
                              <v-layout fluid wrap>
                                <v-flex xs12 class="body-2 font-weight-bold">
                                  <v-text-field
                                    v-model="item.param.extensions"
                                    :rules="[v => !!v || 'Extensions is required']"
                                    hint="Separate with coma. e.g: jpg, png"
                                    label="File extensions"
                                    persistent-hint
                                    required
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-flex>
                      </v-layout>
                      <v-layout fluid wrap>
                        <v-flex offset-xs1 xs11 md12 class="body-2 font-weight-bold text-xs-left">
                          <v-btn
                            outline
                            @click="addParam"
                          >
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <v-select
              v-model="cboCurrencyCode"
              :rules="[v => !!v || 'Please choose currency']"
              :items="currencies"
              item-text="currencyCode"
              item-value="currencyCode"
              label="Currency"
              @change="changeCurrency($event)"
              required
            ></v-select>
            <v-select
              :items="suppliers"
              item-text="name"
              item-value="supplierId"
              v-model="cboSupplier"
              label="Supplier"
            ></v-select>
            <v-select
              v-model="cboMarkup"
              :items="productMarkups"
              item-text="caption"
              item-value="value"
              label="Markup"
              @change="(cboVariant > 0 ? calculateMarkupForVariants(cboMarkup) : calculateMarkup(cboMarkup, txtCostPrice)); forceUpdate();"
            ></v-select>
            <!-- <v-switch
              v-model="switchUnlimitedStock"
              label="Unlimited Stock"
              color="primary"
            ></v-switch> -->
            <v-switch
              v-if="txtWeight <= 0"
              v-model="switchVirtualProductAllowBulkPurchase"
              label="Allow Bulk Purchase"
              color="primary"
            ></v-switch>
            <v-switch
              v-if="serviceIdFromProvider && serviceProviderId"
              v-model="switchSkipServiceProviderSync"
              label="Skip Sync"
              color="primary"
            ></v-switch>
            <!--<v-select
              v-model="cboVariant"
              :items="variantTypes"
              item-text="caption"
              item-value="value"
              :rules="[v => (v === 0 || v === 1 || v === 2) || 'Please select a variant']"
              label="Variants"
              @change="refreshSkus()"
              required
            ></v-select>-->
            <v-card class="mb-4">
              <v-container>
                <h3 class="headline font-weight-bold mb-0 text-xs-left">
                  Product Variants
                  <v-btn
                    v-if="cboVariant < 2"
                    outline
                    @click="addVariant()"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </h3>
                <div>Can create maximum of 2 variants</div>
              </v-container>
              <v-container v-for="variantIndex in cboVariant" :key="variantIndex">
                <v-layout fluid wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="variants[variantIndex-1].variantName"
                      :rules="[v => !!v || 'Variant name is required', v => (v && v.length > 2) || 'Variant name must be 2 or more characters']"
                      label="Variant Name"
                      append-outer-icon="delete"
                      @click:append-outer="removeVariant(variantIndex-1)"
                      @blur="forceUpdate()"
                      required
                    ></v-text-field>
                    <v-card>
                      <v-container>
                        <v-layout fluid wrap>
                          <v-flex xs12>
                            <v-container grid-list-lg v-for="(variantOption, index) in variants[variantIndex-1].options" :key="index">
                              <v-layout fluid wrap>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="variantOption.id"
                                    :rules="[v => !!v || 'Option ID is required']"
                                    label="Option Id"
                                    mask="NNNNN"
                                    @blur="refreshSkus()"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs8>
                                  <v-text-field
                                    v-if="variants[variantIndex-1].options.length > 1"
                                    v-model="variantOption.name"
                                    :rules="[v => !!v || 'Option name is required']"
                                    label="Option Name"
                                    append-outer-icon="delete"
                                    @click:append-outer="removeVariantOption(variantIndex-1, index)"
                                    @blur="refreshSkus()"
                                    required
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="variantOption.name"
                                    :rules="[v => !!v || 'Option name is required']"
                                    @blur="refreshSkus()"
                                    label="Option Name"
                                    required
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <div class="text-xs-right">
                              <v-btn
                                outline
                                @click="addVariantOption(variantIndex-1)"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card class="mt-4" v-if="cboVariant > 0 && skus.length >= 1">
              <v-container>
                <v-layout fluid wrap>
                  <v-flex xs12>
                    <h3 class="headline font-weight-bold text-xs-left">Stock & Pricing</h3>
                    <v-container v-for="sku in skus" :key="sku.sku">
                      <v-layout fluid wrap>
                        <v-flex xs12 md3 class="text-xs-left pr-3">
                          <h4 class="subheading font-weight-bold">{{ sku.sku }}</h4>
                          <div v-for="(option, optionIndex) in sku.options" :key="optionIndex" class="pb-3">
                            {{ option.name }}: <strong>{{ option.value }}</strong>
                          </div>
                          <v-img v-if="stocks[sku.stockKey].productImageId" :src="stocks[sku.stockKey].imageSmallUrl" aspect-ratio="1.2"></v-img>
                          <div v-else style="width:100%; height:150px; border:1px solid #ababab; padding:50px 10px;text-align: center">No Image</div>
                          <div class="text-xs-right">
                            <v-btn
                              outline
                              small
                              @click="openSelectImageDialog(sku.stockKey)"
                            >
                              Select Image
                            </v-btn>
                          </div>
                        </v-flex>
                        <v-flex xs12 md9 v-if="sku.stockKey >= 0">
                          <v-container class="pl-0 pr-0" grid-list-lg>
                            <v-layout fluid wrap>
                              <v-flex xs3>
                                <v-text-field
                                  v-model="stocks[sku.stockKey].locationCode"
                                  label="Location Code"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  v-model="stocks[sku.stockKey].qty"
                                  label="Stock"
                                  :rules="[v => v >= 0 || 'Stock must be 0 or more', v => /^[-|+]?\d*$/.test(v) || 'Stock must be integer']"
                                  type="number"
                                  @blur="forceUpdate"
                                  suffix="pcs"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  v-model="stocks[sku.stockKey].costPrice"
                                  :rules="[v => v >= 0 || 'Cost price must be 0 or more']"
                                  label="Cost Price"
                                  @blur="calculateMarkupForVariants(cboMarkup); forceUpdate();"
                                  type="number"
                                  :prefix="currencySign"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  v-model="stocks[sku.stockKey].weight"
                                  :rules="[v => v >= 0 || 'Weight must be 0 or more']"
                                  label="Weight"
                                  suffix="Kg"
                                  type="number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex sm4 hidden-xs-only>
                              </v-flex>
                              <v-flex xs12 sm8>

                                <v-container grid-list-lg v-if="cboMarkup">
                                  <v-layout fluid wrap>
                                    <v-flex xs12>
                                      <v-card v-if="stocks[sku.stockKey].markupCalculationResult">
                                        <v-container>
                                          <v-layout fluid wrap>
                                            <v-flex xs12>
                                              <h4 class="text-xs-left title font-weight-bold mb-3">Retail Price</h4>
                                              <v-data-table
                                                :headers="bulkPricingHeaders"
                                                :items="stocks[sku.stockKey].markupCalculationResult.retailQtyPricing"
                                                hide-actions
                                                item-key="name"
                                                class="bulk-pricing-table mb-3"
                                              >
                                                <template slot="items" slot-scope="props">
                                                  <tr>
                                                    <td class="text-xs-center">{{ props.item.qty }}</td>
                                                    <td class="text-xs-center">{{ currencySign }}{{ formatPrice(props.item.price) }}</td>
                                                    <td class="text-xs-center"><v-icon v-if="stocks[sku.stockKey].markupCalculationResult.wholesaleQtyLevel === props.item.qty">done</v-icon></td>
                                                  </tr>
                                                </template>
                                              </v-data-table>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                                <v-container grid-list-lg v-else>
                                  <v-layout fluid wrap>
                                    <v-flex xs12>
                                      <h4 class="text-xs-left title font-weight-bold mb-3">Price</h4>
                                      <v-card>
                                        <v-container>
                                          <v-layout fluid wrap>
                                            <v-flex xs4 class="body-2 font-weight-bold">
                                              Qty
                                            </v-flex>
                                            <v-flex xs5 class="body-2 font-weight-bold">
                                              Price
                                            </v-flex>
                                            <v-flex xs3 class="body-2 font-weight-bold">
                                              Wholesale
                                            </v-flex>
                                          </v-layout>
                                          <v-radio-group
                                            v-model="stocks[sku.stockKey].rdoWholesalePriceLevel"
                                            :mandatory="true"
                                            :rules="[v => v >= 0 || 'Please select wholesale level']"
                                          >
                                            <v-layout fluid wrap v-for="(item, index) in stocks[sku.stockKey].retailPricingManual" :key="index">
                                              <v-flex xs4 class="body-2 font-weight-bold">
                                                <v-text-field
                                                  v-model="item.qty"
                                                  :rules="[v => v > 0 || 'Qty must be more than 0', v => /^[-|+]?\d*$/.test(v) || 'Qty must be integer']"
                                                  type="number"
                                                  prepend-icon="cancel"
                                                  @click:prepend="removeRetailPriceForVariant(sku.stockKey, index)"
                                                  hide-details
                                                  solo
                                                  required
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex xs6 class="body-2 font-weight-bold">
                                                <v-text-field
                                                  v-model="item.price"
                                                  :rules="[v => v > 0 || 'Price must be more than 0']"
                                                  type="number"
                                                  :prefix="currencySign"
                                                  hide-details
                                                  solo
                                                  required
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 class="body-2 font-weight-bold">
                                                <v-radio
                                                  color="primary"
                                                  label=""
                                                  :value="index"
                                                  class="mt-2"
                                                ></v-radio>
                                              </v-flex>
                                            </v-layout>
                                          </v-radio-group>
                                          <v-layout fluid wrap>
                                            <v-flex xs6 class="body-2 font-weight-bold text-xs-left">
                                              <v-btn
                                                outline
                                                @click="addRetailPriceForVariant(sku.stockKey)"
                                              >
                                                <v-icon>add</v-icon>
                                              </v-btn>
                                            </v-flex>
                                            <v-flex xs6 class="body-2 font-weight-bold text-xs-right">
                                              <v-btn
                                                v-if="stocks[sku.stockKey].rdoWholesalePriceLevel !== null"
                                                depressed
                                                @click="stocks[sku.stockKey].rdoWholesalePriceLevel = null"
                                              >
                                                Clear wholesale
                                              </v-btn>
                                            </v-flex>
                                            <v-flex xs12 class="body-2 text-xs-left">
                                              <v-text-field
                                                v-model="stocks[sku.stockKey].txtFixedQtyLevels"
                                                placeholder="(Optional) Fixed qty levels. eq. 10,20,50,100"
                                              ></v-text-field>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-container>

                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-flex>
                        <v-divider></v-divider>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-text-field
              v-if="cboVariant === 0"
              v-model="txtStock"
              label="Stock"
              :rules="[v => /^[-|+]?\d*$/.test(v) || 'Stock must be integer']"
              type="number"
              suffix="pcs"
              required
            ></v-text-field>
            <v-text-field
              v-if="cboVariant === 0"
              v-model="txtLocationCode"
              label="Location Code"
            ></v-text-field>
            <v-text-field
              v-if="cboVariant === 0"
              v-model="txtWeight"
              label="Weight"
              type="number"
              suffix="Kg"
              :rules="[v => v >= 0 || 'Weight must be 0 or more']"
              :disabled="profile.type === 'virtual'"
              required
            ></v-text-field>
            <v-text-field
              v-if="cboVariant === 0"
              v-model="txtCostPrice"
              label="Cost Price"
              @blur="calculateMarkup(cboMarkup, txtCostPrice); forceUpdate();"
              :prefix="currencySign"
              type="number"
            ></v-text-field>
            <v-container grid-list-lg v-if="cboVariant === 0">
              <v-layout fluid wrap v-if="cboMarkup && cboMarkup.length > 0">
                <v-flex xs12 md6 v-if="markupCalculationResult">
                  <h4 class="text-xs-left title font-weight-bold mb-3">Retail Price</h4>
                  <v-data-table
                    :headers="bulkPricingHeaders"
                    :items="markupCalculationResult.retailQtyPricing"
                    hide-actions
                    item-key="name"
                    class="bulk-pricing-table mb-3"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="text-xs-center">{{ props.item.qty }}</td>
                        <td class="text-xs-center">{{ currencySign }}{{ formatPrice(props.item.price) }}</td>
                        <td class="text-xs-center"><v-icon v-if="markupCalculationResult.wholesaleQtyLevel === props.item.qty">done</v-icon></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout fluid wrap v-else>
                <v-flex xs12 md6>
                  <h4 class="text-xs-left title font-weight-bold mb-3">Price</h4>
                  <v-card>
                    <v-container>
                      <v-layout fluid wrap>
                        <v-flex xs4 class="body-2 font-weight-bold">
                          Qty
                        </v-flex>
                        <v-flex xs5 class="body-2 font-weight-bold">
                          Price
                        </v-flex>
                        <v-flex xs3 class="body-2 font-weight-bold">
                          Wholesale
                        </v-flex>
                      </v-layout>
                      <v-radio-group
                        v-model="rdoWholesalePriceLevel"
                        :mandatory="true"
                        :rules="[v => v >= 0 || 'Please select wholesale level']"
                      >
                        <v-layout fluid wrap v-for="(item, index) in retailPricingManual" :key="index">
                          <v-flex xs4 class="body-2 font-weight-bold">
                            <v-text-field
                              v-model="item.qty"
                              :rules="[v => v > 0 || 'Qty must be more than 0', v => /^[-|+]?\d*$/.test(v) || 'Qty must be integer']"
                              type="number"
                              prepend-icon="cancel"
                              @click:prepend="removeRetailPrice(index)"
                              hide-details
                              solo
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 class="body-2 font-weight-bold">
                            <v-text-field
                              v-model="item.price"
                              :rules="[v => v > 0 || 'Price must be more than 0']"
                              type="number"
                              :prefix="currencySign"
                              hide-details
                              solo
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 class="body-2 font-weight-bold">
                            <v-radio
                              color="primary"
                              label=""
                              :value="index"
                              class="mt-2"
                            ></v-radio>
                          </v-flex>
                        </v-layout>
                      </v-radio-group>
                      <v-layout fluid wrap>
                        <v-flex xs6 class="body-2 font-weight-bold text-xs-left">
                          <v-btn
                            outline
                            @click="addRetailPrice"
                          >
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 class="body-2 font-weight-bold text-xs-right">
                          <v-btn
                            v-if="rdoWholesalePriceLevel !== null"
                            depressed
                            @click="rdoWholesalePriceLevel = null"
                          >
                            Clear wholesale
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 class="body-2 text-xs-left">
                          <v-text-field
                            v-model="txtFixedQtyLevels"
                            placeholder="(Optional) Fixed qty levels. eq. 10,20,50,100"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container grid-list-lg>
              <v-layout fluid wrap>
                <v-flex xs12>
                  <v-card class="pa-4">
                    <h4 class="text-xs-left title font-weight-bold mb-3">External Website</h4>
                    <v-list two-line v-if="productExternalWebsites.length > 0" style="background-color:transparent;">
                      <template v-for="(website, websiteIndex) in productExternalWebsites">
                        <v-list-tile
                          :key="websiteIndex"
                          avatar
                        >
                          <v-list-tile-avatar tile>
                            <img :src="website.logoUrl">
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title class="body-2">
                              <span style="max-width:80%;">{{ website.websiteName }}</span>
                              <v-btn
                                icon
                                small
                                class="ml-2 mr-0 mt-0 mb-0"
                                @click="openEditExternalWebsiteDialog(website)"
                              >
                                <v-icon small>edit</v-icon>
                              </v-btn>
                              <v-btn
                                icon
                                small
                                class="ml-0 mr-0 mt-0 mb-0"
                                @click="removeExternalWebsite(website)"
                              >
                                <v-icon small>close</v-icon>
                              </v-btn>
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              <a :href="website.url" target="_blank" class="grey--text">
                                {{ website.url }}
                              </a>
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                    <div>
                      <span v-if="productExternalWebsites.length === 0" class="grey--text">No external website</span>
                      <v-btn
                        outline
                        small
                        @click="openAddExternalWebsiteDialog"
                      >
                        Add
                      </v-btn>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn
              block
              large
              color="primary"
              class="mt-4"
              :disabled="!frmValid"
              @click="submitProduct"
            >
              Save
            </v-btn>
          </v-form>
          <v-dialog v-model="dialogSelectImage" max-width="800">
            <v-card>
              <v-card-title class="headline">Select Image</v-card-title>

              <v-card-text class="pt-0 pb-0">
                <v-radio-group v-model="selectImageId" class="radio-group-full-width">
                  <v-container grid-list-sm>
                    <v-layout fluid wrap>
                      <v-flex xs3>
                        <v-card flat class="transparent">
                          <div style="width:100%; height:150px; border:1px solid #ababab; padding:15px 10px;text-align: center">No Image</div>
                          <v-card-actions>
                            <v-radio
                              color="primary"
                              label=""
                              value=""
                            ></v-radio>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                      <v-flex xs3
                        v-for="item in images"
                        :key="item.productImageId"
                      >
                        <v-card flat class="transparent">
                          <v-img :src="item.smallUrl" aspect-ratio="1.2"></v-img>
                          <v-card-actions>
                            <v-radio
                              color="primary"
                              label=""
                              :value="item.productImageId"
                            ></v-radio>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-radio-group>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="selectImage()"
                >
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDeleteImage" max-width="290">
            <v-card>
              <v-card-title class="headline">Confirmation</v-card-title>

              <v-card-text>
                Confirm to delete this image?
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="secondary"
                  class="grey--text"
                  @click="dialogDeleteImage = false"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="primary"
                  @click="dialogDeleteImage = false; deleteImage(dialogProductImageId);"
                >
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogPrimaryImage" max-width="290">
            <v-card>
              <v-card-title class="headline">Confirmation</v-card-title>

              <v-card-text>
                Set as primary image?
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="secondary"
                  class="grey--text"
                  @click="dialogPrimaryImage = false"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="primary"
                  @click="dialogPrimaryImage = false; setImageAsPrimary(dialogProductImageId);"
                >
                  Set as Primary
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogAddImage" max-width="290">
            <v-card>
              <v-card-title class="pb-0">
                <h2>Add Image</h2>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center pa-0">
                      <v-form ref="formImage" v-model="frmAddImageValid" lazy-validation enctype="multipart/form-data">
                        <v-list two-line>
                          <template v-for="(image, imageIndex) in imageUploads">
                            <v-list-tile
                              avatar
                              :key="imageIndex"
                            >
                              <v-list-tile-avatar tile>
                                <img :src="image.url">
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-text-field
                                  v-model="image.description"
                                  :counter="100"
                                ></v-text-field>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider :key="'divider' + imageIndex"></v-divider>
                          </template>
                        </v-list>
                        <!--<img :src="imageUrl" height="150" v-if="imageUrl" style="image-orientation: from-image;"/>
                        <v-text-field label="Product Image" @click.stop='pickFile' v-model='imageName' autofocus></v-text-field>-->
                        <input
                          type="file"
                          multiple
                          style="display: none"
                          ref="image"
                          accept="image/*"
                          @change="onFilePicked"
                          @click="$refs.image.value = null"
                        >
                        <v-btn
                          block
                          color="primary"
                          v-if="imageUploads.length > 0"
                          :disabled="!frmAddImageValid"
                          @click="submitImage"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          block
                          v-else
                          @click="pickFile"
                        >
                          Select
                        </v-btn>
                        <v-switch
                          v-if="imageUploads.length > 0"
                          v-model="switchAddWatermark"
                          label="Add Watermark"
                          color="primary"
                          class="ml-3"
                        ></v-switch>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <v-dialog v-model="dialogImage">
              <v-card>
                <v-card-title class="headline">Choose Image</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat="flat" @click.native="dialogImage = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-dialog>
          <v-dialog v-model="dialogAddVideo" max-width="290">
            <v-card>
              <v-card-title class="pb-0">
                <h2>Add YouTube Video</h2>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center pa-0">
                      <v-form ref="formVideo" v-model="frmAddVideoValid" lazy-validation>
                        <v-list two-line>
                          <v-list-tile
                            avatar
                          >
                            <v-list-tile-avatar tile>
                              <img :src="'https://img.youtube.com/vi/' + videoId + '/0.jpg'">
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-text-field
                                v-model="videoId"
                                required
                              ></v-text-field>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                        <v-btn
                          block
                          color="primary"
                          :disabled="videoId === ''"
                          @click="addVideo"
                        >
                          Add
                        </v-btn>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDeleteVideo" max-width="290">
            <v-card>
              <v-card-title class="headline">Confirmation</v-card-title>

              <v-card-text>
                Confirm to delete this video?
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="secondary"
                  class="grey--text"
                  @click="dialogDeleteVideo = false"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="primary"
                  @click="dialogDeleteVideo = false; deleteVideo(dialogVideoPlatformId, dialogVideoId);"
                >
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogAddCategory" max-width="300px">
            <v-card>
              <v-card-title>
                <strong>Add Category</strong>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="frmAddCategoryValid" lazy-validation>
                  <v-text-field
                    label="Category Name"
                    required
                  ></v-text-field>
                  <v-btn
                    :disabled="!frmAddCategoryValid"
                  >
                    Reset
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogAddExternalWebsite" max-width="290">
        <v-card>
          <v-card-title class="pb-0">
            <h2>Add External Website</h2>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center pa-0">
                  <v-form ref="formAddExternalWebsite" v-model="frmAddExternalWebsiteValid" lazy-validation>
                    <v-select
                      v-model="cboWebsiteId"
                      :items="externalWebsites"
                      item-text="name"
                      item-value="websiteId"
                      label="Website"
                      required
                    ></v-select>
                    <v-text-field
                      v-model="txtWebsiteUrl"
                      required
                    ></v-text-field>
                    <v-btn
                      block
                      color="primary"
                      :disabled="cboWebsiteId === '' || txtWebsiteUrl === ''"
                      @click="addExternalWebsite"
                    >
                      Add
                    </v-btn>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditExternalWebsite" max-width="290">
        <v-card>
          <v-card-title class="pb-0">
            <h2>Edit External Website</h2>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center pa-0">
                  <v-form ref="formEditExternalWebsite" v-model="frmEditExternalWebsiteValid" lazy-validation>
                    <v-select
                      v-model="cboWebsiteId"
                      :items="externalWebsites"
                      item-text="name"
                      item-value="websiteId"
                      label="Website"
                      required
                      disabled
                    ></v-select>
                    <v-text-field
                      v-model="txtWebsiteUrl"
                      required
                    ></v-text-field>
                    <v-btn
                      block
                      color="primary"
                      :disabled="cboWebsiteId === '' || txtWebsiteUrl === ''"
                      @click="editExternalWebsite"
                    >
                      Save
                    </v-btn>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogImportProduct" max-width="290">
        <v-card>
          <v-card-title class="pb-0">
            <h2>Import Product</h2>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center pa-0">
                  <v-form ref="formImportProduct" v-model="frmImportProductValid" lazy-validation>
                    <v-select
                      v-model="cboImportSource"
                      :items="importSources"
                      label="Source"
                      required
                    ></v-select>
                    <v-text-field
                      v-model="txtImportProductId"
                      required
                    ></v-text-field>
                    <v-btn
                      block
                      color="primary"
                      :disabled="cboWebsiteDomain === '' || txtImportProductId === ''"
                      @click="redirectToImportProduct"
                    >
                      Import
                    </v-btn>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm to delete this product?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteProduct()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogViewErpSyncDetails" max-width="1000" v-if="erp && erp.sellerErpLastAttemptRequest && erp.sellerErpLastAttemptResponse">
        <v-card>
          <v-card-title class="headline">ERP Sync Details</v-card-title>

          <v-card-text>
            <div class="font-weight-bold">Request</div>
            <div>{{ erp.sellerErpLastAttemptRequest }}</div>
            <div class="font-weight-bold mt-4">Response</div>
            <div>{{ erp.sellerErpLastAttemptResponse }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogConfirmResyncProductToErp"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm to resync this product?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogConfirmResyncProductToErp = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="resyncProductToErp()"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>

form >>> div.trumbowyg-box.trumbowyg-editor-visible.trumbowyg-en.trumbowyg {
  z-index: 1;
}

form {
  width: 100%;
}

 .radio-group-full-width >>>.v-input__control {
     width: 100% !important;
 }

.v-list__tile__title {
  font-size: 14px;
}
.v-list__tile {
  height: 44px;
}

.level-2 >>> .v-list__group__items {
  margin-left: 25px;
}

.bulk-pricing-table >>> table.v-table tbody td {
  padding: 0 10px;
}

.bulk-pricing-table >>> table.v-table thead th {
  padding: 0 1px;
}

.bulk-pricing-table >>> table.v-table tbody td, table.v-table tbody th {
  height: 34px;
}

@media screen and (max-width: 599px) {

}
@media screen and (min-width: 600px) and (max-width: 959px) {

}
@media screen and (min-width: 960px) and (max-width: 1263px) {

}

</style>

<script>
import { EventBus } from '../main'
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import CategoryDropdown from '@/components/CategoryDropdown.vue'
import router from '../router'
import axios from 'axios'
import { Container, Draggable } from 'vue-smooth-dnd'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css'
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js'

let $ = window.$

export default {
  props: [
    'productId'
  ],
  components: {
    SideDrawer,
    CategoryDropdown,
    Loading,
    Container,
    Draggable,
    Trumbowyg
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      isTrumbowygFullscreen: false,
      loading: false,
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['table'],
          ['removeformat'],
          ['upload'],
          ['fullscreen']
        ],
        plugins: {
          upload: {
            serverPath: process.env.VUE_APP_API_ROOT + '/v1/product/wysiwyg/image',
            fileFieldName: 'image',
            headers: {
              'Authorization': axios.defaults.headers.common['Authorization'],
              'X-API-KEY': axios.defaults.headers.common['X-API-KEY']
            },
            urlPropertyName: 'url'
          },
          resizimg: {
            minSize: 64
          }
        }
      },
      copyProductId: '',
      importProductId: '',
      importSource: '',
      images: [],
      categories: [],
      dialogAddImage: false,
      dialogImage: false,
      frmAddImageValid: false,
      switchAddWatermark: true,
      imageUploads: [],
      imageName: '',
      imageUrl: '',
      imageFile: '',
      videos: [],
      dialogAddVideo: false,
      frmAddVideoValid: false,
      videoId: '',
      videoDesc: '',
      dialogVideoPlatformId: '',
      dialogVideoId: '',
      dialogDeleteVideo: false,
      dialogProductImageId: '',
      dialogDeleteImage: false,
      dialogPrimaryImage: false,
      frmValid: true,
      permalink: '',
      showAiForName: false,
      generatingAiForName: false,
      aiName: '',
      showAiForDescription: false,
      generatingAiForDescription: false,
      aiDescription: '',
      txtName: '',
      txtKeywords: '',
      txtAlternativeKeywords: '',
      currencies: [],
      cboCurrencyCode: this.$store.getters.getProfile.storeCurrencyCode,
      currencySign: this.$store.getters.getProfile.storeCurrencySign,
      currencyDecimals: this.$store.getters.getProfile.storeCurrencyDecimals,
      currencyDecimalSign: this.$store.getters.getProfile.storeCurrencyDecimalSign,
      cboCategory: null,
      cboSecondaryCategory: null,
      txtMetaDescription: '',
      txtDescription: '',
      requiredSelection: [
        {
          caption: 'Required',
          value: true
        },
        {
          caption: 'Optional',
          value: false
        }
      ],
      multipleSelection: [
        {
          caption: 'Allow multiple selection',
          value: true
        },
        {
          caption: 'Only single selection',
          value: false
        }
      ],
      productParams: [
      ],
      paramTypes: [
        {
          caption: 'Text',
          type: 'text'
        },
        {
          caption: 'Select',
          type: 'select'
        },
        {
          caption: 'File',
          type: 'file'
        }
      ],
      paramTextTypes: [
        {
          caption: 'None',
          type: 'none'
        },
        {
          caption: 'Integer',
          type: 'integer'
        },
        {
          caption: 'Decimal',
          type: 'decimal'
        },
        {
          caption: 'Email',
          type: 'email'
        }
      ],
      txtWeight: 0,
      switchUnlimitedStock: false,
      switchVirtualProductAllowBulkPurchase: false,
      serviceIdFromProvider: '',
      serviceProviderId: '',
      switchSkipServiceProviderSync: false,
      switchContainLiquid: false,
      switchContainPaste: false,
      switchContainBattery: false,
      cboStatus: 'active',
      statuses: [
        {
          caption: 'Active',
          value: 'active'
        },
        {
          caption: 'Disabled',
          value: 'disabled'
        }
      ],
      cboVariant: 0,
      variantTypes: [
        {
          caption: 'No variants',
          value: 0
        },
        {
          caption: '1 variant',
          value: 1
        },
        {
          caption: '2 variants',
          value: 2
        }
      ],
      variants: [
        {
          variantName: '',
          options: [
            {
              'id': '',
              'name': ''
            }
          ]
        },
        {
          variantName: '',
          options: [
            {
              'id': '',
              'name': ''
            }
          ]
        }
      ],
      originalVariantCount: 0,
      cboMarkup: '',
      productMarkups: [
        {
          caption: 'None',
          value: ''
        }
      ],
      markupCalculationResult: null,
      stocks: [],
      skus: [],
      suppliers: [
        {
          supplierId: null,
          name: ''
        }
      ],
      cboSupplier: '',
      txtLocationCode: '',
      txtStock: 0,
      txtCostPrice: 0,
      txtPrice: 0,
      txtFixedQtyLevels: '',
      bulkPricingHeaders: [
        {
          text: 'Qty',
          align: 'center',
          sortable: false,
          value: 'qty'
        },
        {
          text: 'Price',
          align: 'center',
          sortable: false,
          value: 'price'
        },
        {
          text: 'Wholesale',
          align: 'center',
          sortable: false,
          value: 'wholesale'
        }
      ],
      retailPricingManual: [
        {
          qty: 1,
          price: 0
        }
      ],
      rdoWholesalePriceLevel: null,
      wholesalePricingManual: [
        {
          qty: 1,
          price: 0
        }
      ],
      externalWebsites: [],
      productExternalWebsites: [],
      dialogAddExternalWebsite: false,
      frmAddExternalWebsiteValid: false,
      cboWebsiteId: '',
      txtWebsiteUrl: '',
      dialogEditWebsiteId: '',
      dialogEditExternalWebsite: false,
      frmEditExternalWebsiteValid: false,
      dialogAddCategory: false,
      frmAddCategoryValid: false,
      dialogDelete: false,
      dialogSelectImage: false,
      selectImageId: '',
      selectImageSkuStockIndex: null,
      selectImageParamIndex: null,
      selectImageParamItemIndex: null,
      countries: [],
      cboUnavailableCountries: [],
      erp: [],
      dialogViewErpSyncDetails: false,
      dialogConfirmResyncProductToErp: false,
      dialogImportProduct: false,
      frmImportProductValid: false,
      importSources: [],
      cboImportSource: '',
      txtImportProductId: ''
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getCurrencies()
    this.getImportSources()
    this.getCountries()
    if (this.productId) {
      // no need to call getCategories anymore bcos already loaded inside getProduct()
      this.getProduct(this.productId)
    } else {
      if (typeof this.$route.query.copy !== 'undefined' && this.$route.query.copy.length > 0) {
        // no need to call getCategories anymore bcos already loaded inside copyProduct()
        this.copyProductId = this.$route.query.copy
        this.copyProduct(this.copyProductId)
      } else if (typeof this.$route.query.import !== 'undefined' && this.$route.query.import.length > 0 && typeof this.$route.query.source !== 'undefined' && this.$route.query.source.length > 0) {
        // no need to call getCategories anymore bcos already loaded inside importProduct()
        this.importProductId = this.$route.query.import
        this.importSource = this.$route.query.source
        this.importProduct(this.importSource, this.importProductId)
      } else {
        this.getCategories()
      }
    }
    this.getMarkups()
    this.getSuppliers()
    this.getExternalWebsites()
    this.disableBottomDetector()

    var _this = this
    $('#trumbowyg')
      .trumbowyg() // Build Trumbowyg on the #editor element
      .on('tbwopenfullscreen', function () { _this.drawer = false; _this.isTrumbowygFullscreen = true })
      .on('tbwclosefullscreen', function () { _this.isTrumbowygFullscreen = false; _this.drawer = true })
  },

  computed: {
  },

  watch: {
    cboMarkup (newValue, oldValue) {
      if (newValue.length > 0) {
        if (this.cboVariant === 0) {
          if (this.txtCostPrice > 0) {
            this.calculateMarkup(newValue, this.txtCostPrice)
          }
        } else {
          this.calculateMarkupForVariants(newValue)
        }
      }
    },
    txtCostPrice (newValue, oldValue) {
      if (newValue > 0) {
        if (typeof this.cboMarkup !== 'undefined') {
          if (this.cboMarkup.length > 0) {
            this.calculateMarkup(this.cboMarkup, newValue)
          }
        }
      }
    },
    showAiForName (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.generateAiName(this.txtName)
      }
    },
    showAiForDescription (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.generateAiDescription(this.txtDescription)
      }
    }
  },

  methods: {
    generateAiName: function (currentName) {
      var _this = this
      _this.generatingAiForName = true
      _this.aiName = ''
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/ai/title',
        {
          title: currentName
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(resp => {
          console.log(resp.data)
          _this.generatingAiForName = false
          if (resp.data.status === 'success') {
            _this.aiName = resp.data.data.result
          } else {
            console.log('unable to load ai improvement for name: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.generatingAiForName = false
          }
        })
    },
    generateAiDescription: function (currentDescription) {
      var _this = this
      _this.generatingAiForDescription = true
      _this.aiDescription = ''
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/ai/description',
        {
          description: currentDescription
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(resp => {
          console.log(resp.data)
          _this.generatingAiForDescription = false
          if (resp.data.status === 'success') {
            _this.aiDescription = resp.data.data.result
          } else {
            console.log('unable to load ai improvement for description: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.generatingAiForDescription = false
          }
        })
    },
    applyDrag: function (arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },
    onDropImage: function (dropResult) {
      this.images = this.applyDrag(this.images, dropResult)
    },
    onDropVideo: function (dropResult) {
      this.videos = this.applyDrag(this.videos, dropResult)
    },
    removeUnavailableCountry: function (item) {
      this.cboUnavailableCountries.splice(this.cboUnavailableCountries.indexOf(item), 1)
      this.cboUnavailableCountries = [...this.cboUnavailableCountries]
    },
    openAddVideoDialog: function () {
      this.frmAddVideoValid = false
      this.videoId = ''
      this.videoDesc = ''
      this.dialogAddVideo = true
    },
    addVideo: function () {
      var _this = this
      var videoPlatformId = 'YOUTUBE'
      var isVideoExist = false
      for (var c = 0; c < _this.videos.length; c++) {
        if (_this.videos[c].videoPlatformId === videoPlatformId && _this.videos[c].videoId === _this.videoId) {
          isVideoExist = true
          break
        }
      }

      if (!isVideoExist) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/integration/youtube/video/' + _this.videoId)
          .then(resp => {
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.videos.push({
                'videoPlatformId': videoPlatformId,
                'videoId': _this.videoId,
                'videoUrl': 'https://youtu.be/' + _this.videoId,
                'description': resp.data.data.items[0].snippet.localized.title,
                'thumbUrl': resp.data.data.items[0].snippet.thumbnails.default.url,
                'mediumUrl': resp.data.data.items[0].snippet.thumbnails.high.url,
                'largeUrl': (typeof resp.data.data.items[0].snippet.thumbnails.standard !== 'undefined' ? resp.data.data.items[0].snippet.thumbnails.standard.url : resp.data.data.items[0].snippet.thumbnails.high.url),
                'duration': resp.data.data.items[0].contentDetails.duration,
                'publishedAt': resp.data.data.items[0].snippet.publishedAt
              })
              _this.dialogAddVideo = false
            } else {
              console.log('unable to load video details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      } else {
        window.alert('Video already in the list')
      }
    },
    openDeleteVideoDialog: function (videoPlatformId, videoId) {
      this.dialogVideoPlatformId = videoPlatformId
      this.dialogVideoId = videoId
      this.dialogDeleteVideo = true
    },
    deleteVideo: function (videoPlatformId, videoId) {
      // dont delete the video when copying, just remove from array
      this.removeVideoFromArray(videoPlatformId, videoId)
    },
    removeVideoFromArray: function (videoPlatformId, videoId) {
      for (var c = 0; c < this.videos.length; c++) {
        if (this.videos[c].videoPlatformId === videoPlatformId && this.videos[c].videoId === videoId) {
          this.videos.splice(c, 1)
          break
        }
      }
    },
    openSelectImageDialog: function (skuStockIndex = null, paramIndex = null, paramItemIndex = null) {
      this.selectImageSkuStockIndex = skuStockIndex
      this.selectImageParamIndex = paramIndex
      this.selectImageParamItemIndex = paramItemIndex

      this.selectImageId = ''
      if (this.selectImageSkuStockIndex !== null) {
        if (typeof this.stocks[this.selectImageSkuStockIndex] !== 'undefined') {
          this.selectImageId = this.stocks[this.selectImageSkuStockIndex].productImageId
        }
      } else if (this.selectImageParamIndex !== null && this.selectImageParamItemIndex !== null) {
        if (typeof this.productParams[this.selectImageParamIndex]['param']['items'][this.selectImageParamItemIndex] !== 'undefined') {
          this.selectImageId = this.productParams[this.selectImageParamIndex]['param']['items'][this.selectImageParamItemIndex].productImageId
        }
      }

      this.dialogSelectImage = true
    },
    selectImage: function () {
      var i
      if (this.selectImageSkuStockIndex !== null) {
        if (typeof this.stocks[this.selectImageSkuStockIndex] !== 'undefined') {
          this.stocks[this.selectImageSkuStockIndex].productImageId = this.selectImageId
          for (i in this.images) {
            if (this.images[i].productImageId === this.selectImageId) {
              this.stocks[this.selectImageSkuStockIndex].imageSmallUrl = this.images[i].smallUrl
              break
            }
          }
        }
      } else if (this.selectImageParamIndex !== null && this.selectImageParamItemIndex !== null) {
        if (typeof this.productParams[this.selectImageParamIndex]['param']['items'][this.selectImageParamItemIndex] !== 'undefined') {
          this.productParams[this.selectImageParamIndex]['param']['items'][this.selectImageParamItemIndex].productImageId = this.selectImageId
          for (i in this.images) {
            if (this.images[i].productImageId === this.selectImageId) {
              this.productParams[this.selectImageParamIndex]['param']['items'][this.selectImageParamItemIndex].imageSmallUrl = this.images[i].smallUrl
              break
            }
          }
        }
      }
      this.dialogSelectImage = false
    },
    getExternalWebsites: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/websites')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.externalWebsites = resp.data.data
          } else {
            console.log('unable to load external websites: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    openAddExternalWebsiteDialog: function () {
      this.frmAddExternalWebsiteValid = false
      this.cboWebsiteId = ''
      this.txtWebsiteUrl = ''
      this.dialogAddExternalWebsite = true
    },
    addExternalWebsite: function () {
      var _this = this
      var isWebsiteExist = false
      for (var c = 0; c < _this.productExternalWebsites.length; c++) {
        if (_this.productExternalWebsites[c].websiteId === _this.cboWebsiteId) {
          isWebsiteExist = true
          break
        }
      }

      if (!isWebsiteExist) {
        let isWebsiteValid = false
        for (let d = 0; d < _this.externalWebsites.length; d++) {
          if (_this.externalWebsites[d].websiteId === _this.cboWebsiteId) {
            _this.productExternalWebsites.push({
              'websiteId': _this.cboWebsiteId,
              'websiteName': _this.externalWebsites[d].name,
              'logoUrl': _this.externalWebsites[d].logoUrl,
              'url': _this.txtWebsiteUrl
            })
            isWebsiteValid = true
            _this.dialogAddExternalWebsite = false
            break
          }
        }

        if (!isWebsiteValid) {
          window.alert('Invalid Website')
        }
      } else {
        window.alert('Website ' + _this.productExternalWebsites[c].websiteName + ' already in the list')
      }
    },
    removeExternalWebsite: function (item) {
      this.productExternalWebsites.splice(this.productExternalWebsites.indexOf(item), 1)
      this.productExternalWebsites = [...this.productExternalWebsites]
    },
    openEditExternalWebsiteDialog: function (item) {
      this.dialogEditWebsiteId = this.productExternalWebsites.indexOf(item)
      if (this.dialogEditWebsiteId >= 0) {
        this.frmEditExternalWebsiteValid = false
        this.cboWebsiteId = this.productExternalWebsites[this.dialogEditWebsiteId].websiteId
        this.txtWebsiteUrl = this.productExternalWebsites[this.dialogEditWebsiteId].url
        this.dialogEditExternalWebsite = true
      } else {
        window.alert('Unable to edit')
      }
    },
    editExternalWebsite: function () {
      this.productExternalWebsites[this.dialogEditWebsiteId].url = this.txtWebsiteUrl
      this.dialogEditExternalWebsite = false
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.currencies = []
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === _this.profile.storeCurrencyCode || resp.data.data[i].currencyCode === _this.def.currency.currencyCode) {
                _this.currencies.push(resp.data.data[i])
              }
            }
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    changeCurrency: function (currencyCode) {
      console.log('changeCurrency: ' + currencyCode)
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          this.currencyDecimalSign = this.currencies[i].decimalSign
          this.currencyDecimals = this.currencies[i].decimals
          this.currencySign = this.currencies[i].sign
          break
        }
      }
    },
    initParamInput: function (type, index) {
      if (type === 'text') {
        this.productParams[index].param = { 'minLength': 1, 'maxLength': 100, 'validationType': 'none' }
      } else if (type === 'select') {
        this.productParams[index].param = { 'isMultipleSelection': false, 'items': [{ 'name': '', 'price': 0 }] }
      } else if (type === 'file') {
        this.productParams[index].param = { 'extensions': '' }
      }
    },
    addParamItem: function (paramIndex) {
      this.productParams[paramIndex].param.items.push({ 'name': '', 'price': 0 })
      this.forceUpdate()
    },
    removeParamItem: function (paramIndex, itemIndex) {
      this.productParams[paramIndex].param.items.splice(itemIndex, 1)
      this.forceUpdate()
    },
    addParam: function () {
      this.productParams.push({ 'name': '', 'type': null, 'desc': '', 'param': null })
      this.forceUpdate()
    },
    removeParam: function (index) {
      this.productParams.splice(index, 1)
      this.forceUpdate()
    },
    addRetailPrice: function () {
      this.retailPricingManual.push({ 'qty': '', 'price': '' })
      this.forceUpdate()
    },
    removeRetailPrice: function (index) {
      this.retailPricingManual.splice(index, 1)
      this.forceUpdate()
    },
    addRetailPriceForVariant: function (stockIndex) {
      this.stocks[stockIndex].retailPricingManual.push({ 'qty': '', 'price': '' })
      this.forceUpdate()
    },
    removeRetailPriceForVariant: function (stockIndex, index) {
      this.stocks[stockIndex].retailPricingManual.splice(index, 1)
      this.forceUpdate()
    },
    getStockArrayKey: function (sku) {
      var i
      for (i = 0; i < this.stocks.length; i++) {
        if (this.stocks[i].sku === sku) {
          return i
        }
      }

      var options
      for (i = 0; i < this.skus.length; i++) {
        if (this.skus[i].sku === sku) {
          options = this.skus[i].options
        }
      }

      var newStock = {
        sku: sku,
        options: options,
        locationCode: '',
        weight: 0,
        qty: 0,
        costPrice: 0,
        price: 0,
        retailPricingManual: [
          {
            qty: 1,
            price: 0
          }
        ],
        txtFixedQtyLevels: '',
        rdoWholesalePriceLevel: null,
        markupCalculationResult: null
      }
      this.stocks.push(newStock)
      return (this.stocks.length - 1)
    },
    addVariantOption: function (variantIndex) {
      this.variants[variantIndex].options.push({ 'id': '', 'name': '' })
      this.forceUpdate()
    },
    removeVariantOption: function (variantIndex, optionIndex) {
      this.variants[variantIndex].options.splice(optionIndex, 1)
      this.refreshSkus()
      this.forceUpdate()
    },
    addVariant: function () {
      this.cboVariant++
      this.variants.push({
        variantName: '',
        options: [
          {
            'id': '',
            'name': ''
          }
        ]
      })
      this.refreshSkus()
      this.forceUpdate()
    },
    removeVariant: function (variantIndex) {
      this.variants.splice(variantIndex, 1)
      this.cboVariant--
      this.refreshSkus()
      this.forceUpdate()
    },
    refreshSkus: function () {
      var result = []
      var i, j, row
      if (this.cboVariant === 1) {
        for (i = 0; i < this.variants[0].options.length; i++) {
          if (this.variants[0].variantName !== '' && this.variants[0].options[i].id !== '') {
            row = {
              sku: (this.productId ? this.productId.replace(/MV-/g, 'SKU-') : 'PRODUCTID') + '-' + this.variants[0].options[i].id.toUpperCase(),
              options: [
                {
                  'name': this.variants[0].variantName,
                  'value': this.variants[0].options[i].id
                }
              ],
              stockKey: null
            }
            result.push(row)
          }
        }
      } else if (this.cboVariant === 2) {
        for (i = 0; i < this.variants[0].options.length; i++) {
          if (this.variants[0].variantName !== '' && this.variants[0].options[i].id !== '') {
            for (j = 0; j < this.variants[1].options.length; j++) {
              if (this.variants[1].variantName !== '' && this.variants[1].options[j].id !== '') {
                row = {
                  sku: (this.productId ? this.productId.replace(/MV-/g, 'SKU-') : 'PRODUCTID') + '-' + this.variants[0].options[i].id.toUpperCase() + '-' + this.variants[1].options[j].id.toUpperCase(),
                  options: [
                    {
                      'name': this.variants[0].variantName,
                      'value': this.variants[0].options[i].id
                    },
                    {
                      'name': this.variants[1].variantName,
                      'value': this.variants[1].options[j].id
                    }
                  ],
                  stockKey: null
                }
                result.push(row)
              }
            }
          }
        }
      }
      this.skus = result

      // determine stockKey for each sku
      for (i = 0; i < this.skus.length; i++) {
        this.skus[i].stockKey = this.getStockArrayKey(this.skus[i].sku)
      }
    },
    openDeleteProductDialog: function () {
      this.dialogDelete = true
    },
    deleteProduct: function () {
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/product/' + _this.productId)
        .then(resp => {
          _this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/products')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    openImportProductDialog: function () {
      this.frmImportProductValid = false

      // use previous value or auto select first domain
      this.cboImportSource = this.cboImportSource || this.importSources[0]

      this.txtImportProductId = ''
      this.dialogImportProduct = true
    },
    redirectToImportProduct: function () {
      if (this.cboImportSource && this.txtImportProductId) {
        this.$router.push({
          path: this.$route.path,
          query: {
            import: this.txtImportProductId,
            source: this.cboImportSource
          }
        })
      }
    },
    resyncProductToErp: function () {
      var _this = this
      _this.loading = true
      var dataJson = {
        productIds: [_this.productId]
      }
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/erp/sync', dataJson, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          _this.loading = false
          console.log(resp.data)
          _this.dialogConfirmResyncProductToErp = false
          if (resp.data.status === 'success') {
            _this.getProduct(this.productId)
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    openPrimaryImageDialog: function (productImageId) {
      this.dialogProductImageId = productImageId
      this.dialogPrimaryImage = true
    },
    openDeleteImageDialog: function (productImageId) {
      this.dialogProductImageId = productImageId
      this.dialogDeleteImage = true
    },
    deleteImage: function (productImageId) {
      // dont delete the image when copying, just remove from array
      this.removeImageFromArray(productImageId)
    },
    removeImageFromArray: function (productImageId) {
      for (var c = 0; c < this.images.length; c++) {
        if (this.images[c].productImageId === productImageId) {
          this.images.splice(c, 1)

          // remove image if found in sku stocks
          for (var i in this.stocks) {
            if (typeof this.stocks[i] !== 'undefined') {
              if (typeof this.stocks[i].productImageId !== 'undefined') {
                if (this.stocks[i].productImageId === productImageId) {
                  this.stocks[i].productImageId = ''
                  this.stocks[i].imageSmallUrl = ''
                }
              }
            }
          }

          // remove image if found in params
          for (var j in this.productParams) {
            if (typeof this.productParams[j]['param']['items'] !== 'undefined') {
              for (var k in this.productParams[j]['param']['items']) {
                if (typeof this.productParams[j]['param']['items'][k].productImageId !== 'undefined') {
                  if (this.productParams[j]['param']['items'][k].productImageId === productImageId) {
                    this.productParams[j]['param']['items'][k].productImageId = ''
                    this.productParams[j]['param']['items'][k].imageSmallUrl = ''
                  }
                }
              }
            }
          }

          break
        }
      }
    },
    getImportSources: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/import/sources')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.importSources = resp.data.data
          } else {
            console.log('unable to load import sources: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    importProduct: function (sourceName, productId) {
      var _this = this
      if (sourceName && productId) {
        _this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/import', {
          sourceName: sourceName,
          sourceProductId: productId
        })
          .then(resp => {
            console.log('importProduct')
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.processCopyProduct(resp, true)
            } else {
              window.alert('Import fail: ' + resp.data.message)
            }
            _this.loading = false
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    copyProduct: function (productId) {
      var _this = this
      if (productId) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/' + productId)
          .then(resp => {
            console.log('copyProduct')
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.processCopyProduct(resp)
            } else {
              console.log('unable to load product copy details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    isCategoryExist: function (targetCategoryId, categories) {
      for (var i = 0; i < categories.length; i++) {
        // Check current category
        console.log(categories[i].categoryId, targetCategoryId)
        if (categories[i].categoryId === targetCategoryId) {
          return true
        }

        // Recursively check children if they exist
        if (categories[i].childs && categories[i].childs.length > 0) {
          if (this.isCategoryExist(targetCategoryId, categories[i].childs)) {
            return true
          }
        }
      }
      return false
    },
    processCopyProduct: async function (resp, isImportProduct = false) {
      // keep the categories result in memory only temporary in this method
      // the getCategories() method also emits categories list to other components
      const categories = await this.getCategories()

      let i, j
      this.images = resp.data.data.images
      this.videos = resp.data.data.videos
      this.txtName = resp.data.data.name + ' - ' + this.profile.storeCountryName
      this.txtKeywords = resp.data.data.keywords
      this.txtAlternativeKeywords = resp.data.data.alternativeKeywords

      if (isImportProduct) {
        // for import product across websites, check if the category exists in the current website
        if (resp.data.data.category.primary !== null) {
          if (this.isCategoryExist(resp.data.data.category.primary.categoryId, categories)) {
            this.cboCategory = resp.data.data.category.primary.categoryId
          }
        }

        if (resp.data.data.category.secondary.length) {
          if (this.isCategoryExist(resp.data.data.category.secondary[0].categoryId, categories)) {
            this.cboSecondaryCategory = resp.data.data.category.secondary[0].categoryId
          }
        }
      } else {
        // for copy product within the same website, just use the category id
        if (resp.data.data.category.primary !== null) {
          this.cboCategory = resp.data.data.category.primary.categoryId
        }
        if (resp.data.data.category.secondary.length) {
          this.cboSecondaryCategory = resp.data.data.category.secondary[0].categoryId
        }
      }
      this.cboCurrencyCode = resp.data.data.currencyCode
      this.currencyDecimalSign = resp.data.data.currencyDecimalSign
      this.currencyDecimals = resp.data.data.currencyDecimals
      this.currencySign = resp.data.data.currencySign
      this.txtDescription = resp.data.data.description
      this.txtMetaDescription = resp.data.data.metaDescription
      this.switchContainLiquid = (resp.data.data.isContainLiquid === '1')
      this.switchContainPaste = (resp.data.data.isContainPaste === '1')
      this.switchContainBattery = (resp.data.data.isContainBattery === '1')
      // this.txtWeight = resp.data.data.weight
      this.switchVirtualProductAllowBulkPurchase = (resp.data.data.isVirtualProductAllowBulkPurchase === '1')
      this.cboVariant = Number(resp.data.data.options.length)
      this.cboStatus = resp.data.data.status
      this.skus = resp.data.data.skus

      this.retailPricingManual = resp.data.data.skus[0].retailQtyPricing
      for (i in resp.data.data.skus[0].retailQtyPricing) {
        if (resp.data.data.skus[0].retailQtyPricing[i].qty === Number(resp.data.data.skus[0].wholesaleQtyLevel)) {
          this.rdoWholesalePriceLevel = Number(i)
        }
      }

      this.productParams = []
      if (resp.data.data.params) {
        for (i = 0; i < resp.data.data.params.length; i++) {
          var param = {}
          param.name = resp.data.data.params[i].name
          param.desc = resp.data.data.params[i].hint
          param.type = resp.data.data.params[i].type

          if (resp.data.data.params[i].type === 'select') {
            var items = []
            for (j = 0; j < resp.data.data.params[i].selectionItems.length; j++) {
              items.push({
                name: resp.data.data.params[i].selectionItems[j].selectionName,
                price: Number(resp.data.data.params[i].selectionItems[j].price),
                weight: Number(resp.data.data.params[i].selectionItems[j].weight),
                productImageId: resp.data.data.params[i].selectionItems[j].productImageId,
                imageSmallUrl: resp.data.data.params[i].selectionItems[j].imageSmallUrl
              })
            }
            param.param = {
              items: items,
              isMultipleSelection: (resp.data.data.params[i].isMultipleSelection === '1')
            }
          } else if (resp.data.data.params[i].type === 'text') {
            param.param = {
              minLength: Number(resp.data.data.params[i].textMinLength),
              maxLength: Number(resp.data.data.params[i].textMaxLength),
              validationType: resp.data.data.params[i].textValidationType
            }
          } else if (resp.data.data.params[i].type === 'file') {
            var extensions = ''
            for (j = 0; j < resp.data.data.params[i].fileExtensions.length; j++) {
              if (extensions.length > 0) {
                extensions += ', '
              }
              extensions += resp.data.data.params[i].fileExtensions[j]
            }
            param.param = {
              extensions: extensions
            }
          }

          this.productParams.push(param)
        }
      }

      if (this.cboVariant === 0) {
        this.txtStock = isImportProduct ? resp.data.data.skus[0].qty : 0
        this.txtLocationCode = isImportProduct ? resp.data.data.skus[0].locationCode : ''
        this.txtWeight = Number(resp.data.data.skus[0].weight)
        this.txtCostPrice = isImportProduct ? resp.data.data.skus[0].costPrice : 0
        this.txtPrice = Number(resp.data.data.retailPrice)

        // load fixed qty levels
        var fixedQtyText = ''
        for (j in resp.data.data.skus[0].fixedQtyLevels) {
          if (fixedQtyText.length > 0) {
            fixedQtyText = fixedQtyText + ','
          }
          fixedQtyText = fixedQtyText + resp.data.data.skus[0].fixedQtyLevels[j]
        }
        this.txtFixedQtyLevels = fixedQtyText
      } else {
        // variants
        this.variants = []
        for (i = 0; i < resp.data.data.options.length; i++) {
          var tmpOptions = []
          for (j = 0; j < resp.data.data.options[i].values.length; j++) {
            tmpOptions.push({
              'id': resp.data.data.options[i].values[j].valueCode,
              'name': resp.data.data.options[i].values[j].valueName
            })
          }

          this.variants[i] = {
            'variantName': resp.data.data.options[i].optionName,
            'productOptionId': resp.data.data.options[i].productOptionId,
            'options': tmpOptions
          }
        }

        this.refreshSkus()

        // stocks and pricing
        for (i = 0; i < resp.data.data.skus.length; i++) {
          // convert sku to PRODUCTID-XXX format (because this new product have no SKU yet)
          var newSku = ''
          if (resp.data.data.skus[i].sku.indexOf('PRODUCTID') !== -1) {
            newSku = resp.data.data.skus[i].sku
          } else {
            var splitSku = resp.data.data.skus[i].sku.split('-')
            newSku = 'PRODUCTID-' + splitSku[2]
            if (splitSku.length === 4) {
              newSku = newSku + '-' + splitSku[3]
            }
          }
          var stockKey = this.getStockArrayKey(newSku)
          this.stocks[stockKey].locationCode = isImportProduct ? resp.data.data.skus[i].locationCode : ''
          this.stocks[stockKey].qty = isImportProduct ? resp.data.data.skus[i].qty : 0
          this.stocks[stockKey].price = 0
          this.stocks[stockKey].costPrice = isImportProduct ? resp.data.data.skus[i].costPrice : 0
          this.stocks[stockKey].weight = resp.data.data.skus[i].weight
          this.stocks[stockKey].productImageId = resp.data.data.skus[i].productImageId
          this.stocks[stockKey].imageSmallUrl = resp.data.data.skus[i].imageSmallUrl

          // load pricing into retailPricingManual
          this.stocks[stockKey].retailPricingManual = resp.data.data.skus[i].retailQtyPricing
          for (j = 0; j < resp.data.data.skus[i].retailQtyPricing.length; j++) {
            // resp.data.data.skus[i].retailQtyPricing[j].price = 0
            // resp.data.data.skus[i].retailQtyPricing[j].priceInBase = 0
            if (resp.data.data.skus[i].retailQtyPricing[j].qty === Number(resp.data.data.skus[i].wholesaleQtyLevel)) {
              this.stocks[stockKey].rdoWholesalePriceLevel = j
            }
          }

          // load fixed qty levels
          var fixedQtyLevels = ''
          for (j = 0; j < resp.data.data.skus[i].fixedQtyLevels.length; j++) {
            if (fixedQtyLevels.length > 0) {
              fixedQtyLevels = fixedQtyLevels + ','
            }
            fixedQtyLevels = fixedQtyLevels + resp.data.data.skus[i].fixedQtyLevels[j]
          }
          this.stocks[stockKey].txtFixedQtyLevels = fixedQtyLevels
        }
      }
      console.log('stocks after')
      console.log(this.stocks)
      this.forceUpdate()
    },
    getProduct: function (productId) {
      var _this = this
      var i, j, k
      if (productId) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/' + productId)
          .then(resp => {
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.erp = resp.data.data.erp
              _this.images = resp.data.data.images
              _this.videos = resp.data.data.videos
              _this.permalink = resp.data.data.permalink
              _this.txtName = resp.data.data.name
              _this.txtKeywords = resp.data.data.keywords
              _this.txtAlternativeKeywords = resp.data.data.alternativeKeywords
              if (resp.data.data.category.primary !== null) {
                _this.cboCategory = resp.data.data.category.primary.categoryId
              }
              if (resp.data.data.category.secondary.length) {
                _this.cboSecondaryCategory = resp.data.data.category.secondary[0].categoryId
              }
              _this.txtDescription = resp.data.data.description
              _this.txtMetaDescription = resp.data.data.metaDescription
              _this.txtWeight = this.formatPrice(resp.data.data.weight)
              // _this.switchUnlimitedStock = (resp.data.data.isUnlimitedStock === '1')
              _this.switchVirtualProductAllowBulkPurchase = (resp.data.data.isVirtualProductAllowBulkPurchase === '1')
              _this.cboVariant = Number(resp.data.data.options.length)
              _this.switchContainLiquid = (resp.data.data.isContainLiquid === '1')
              _this.switchContainPaste = (resp.data.data.isContainPaste === '1')
              _this.switchContainBattery = (resp.data.data.isContainBattery === '1')
              _this.cboStatus = resp.data.data.status
              _this.cboCurrencyCode = resp.data.data.currencyCode
              _this.currencyDecimalSign = resp.data.data.currencyDecimalSign
              _this.currencyDecimals = resp.data.data.currencyDecimals
              _this.currencySign = resp.data.data.currencySign
              _this.cboMarkup = resp.data.data.productMarkupId
              _this.cboSupplier = resp.data.data.supplierId
              _this.skus = resp.data.data.skus
              _this.serviceIdFromProvider = resp.data.data.serviceIdFromProvider
              _this.serviceProviderId = resp.data.data.serviceProviderId
              _this.switchSkipServiceProviderSync = (resp.data.data.isSkipServiceProviderSync === '1')

              if (_this.cboMarkup.length > 0) {
                _this.markupCalculationResult = {
                  retailPrice: Number(resp.data.data.wholesalePrice),
                  retailQtyPricing: resp.data.data.skus[0].retailQtyPricing,
                  wholesaleQtyLevel: Number(resp.data.data.skus[0].wholesaleQtyLevel),
                  wholesalePrice: Number(resp.data.data.retailPrice)
                }
              } else {
                _this.retailPricingManual = resp.data.data.skus[0].retailQtyPricing
                for (i in resp.data.data.skus[0].retailQtyPricing) {
                  if (resp.data.data.skus[0].retailQtyPricing[i].qty === Number(resp.data.data.skus[0].wholesaleQtyLevel)) {
                    _this.rdoWholesalePriceLevel = Number(i)
                  }
                }
              }

              _this.productParams = []
              if (resp.data.data.params) {
                for (i = 0; i < resp.data.data.params.length; i++) {
                  var param = {}
                  param.name = resp.data.data.params[i].name
                  param.desc = resp.data.data.params[i].hint
                  param.type = resp.data.data.params[i].type

                  if (resp.data.data.params[i].type === 'select') {
                    var items = []
                    for (j = 0; j < resp.data.data.params[i].selectionItems.length; j++) {
                      items.push({
                        name: resp.data.data.params[i].selectionItems[j].selectionName,
                        price: Number(resp.data.data.params[i].selectionItems[j].price),
                        weight: Number(resp.data.data.params[i].selectionItems[j].weight),
                        productImageId: resp.data.data.params[i].selectionItems[j].productImageId,
                        imageSmallUrl: resp.data.data.params[i].selectionItems[j].imageSmallUrl
                      })
                    }
                    param.param = {
                      items: items,
                      isMultipleSelection: (resp.data.data.params[i].isMultipleSelection === '1')
                    }
                  } else if (resp.data.data.params[i].type === 'text') {
                    param.param = {
                      minLength: Number(resp.data.data.params[i].textMinLength),
                      maxLength: Number(resp.data.data.params[i].textMaxLength),
                      validationType: resp.data.data.params[i].textValidationType
                    }
                  } else if (resp.data.data.params[i].type === 'file') {
                    var extensions = ''
                    for (j = 0; j < resp.data.data.params[i].fileExtensions.length; j++) {
                      if (extensions.length > 0) {
                        extensions += ', '
                      }
                      extensions += resp.data.data.params[i].fileExtensions[j]
                    }
                    param.param = {
                      extensions: extensions
                    }
                  }

                  _this.productParams.push(param)
                }
              }

              if (_this.cboVariant === 0) {
                _this.txtStock = Number(resp.data.data.skus[0].qty)
                _this.txtLocationCode = resp.data.data.skus[0].locationCode
                _this.txtWeight = resp.data.data.skus[0].weight
                _this.txtCostPrice = Number(resp.data.data.skus[0].costPrice)
                _this.txtPrice = Number(resp.data.data.retailPrice)

                // load fixed qty levels
                var fixedQtyText = ''
                for (k in resp.data.data.skus[0].fixedQtyLevels) {
                  if (fixedQtyText.length > 0) {
                    fixedQtyText = fixedQtyText + ','
                  }
                  fixedQtyText = fixedQtyText + resp.data.data.skus[0].fixedQtyLevels[k]
                }
                _this.txtFixedQtyLevels = fixedQtyText
              } else {
                // variants
                _this.variants = []
                console.log(_this.variants)
                console.log('variants')
                console.log(resp.data.data.options)
                for (i = 0; i < resp.data.data.options.length; i++) {
                  var tmpOptions = []
                  for (j = 0; j < resp.data.data.options[i].values.length; j++) {
                    tmpOptions.push({ 'id': resp.data.data.options[i].values[j].valueCode, 'name': resp.data.data.options[i].values[j].valueName })
                  }

                  _this.variants[i] = {
                    'variantName': resp.data.data.options[i].optionName,
                    'productOptionId': resp.data.data.options[i].productOptionId,
                    'options': tmpOptions
                  }
                }
                console.log(_this.variants)
                _this.refreshSkus()

                // stocks and pricing
                for (i = 0; i < resp.data.data.skus.length; i++) {
                  var stockKey = _this.getStockArrayKey(resp.data.data.skus[i].sku)
                  _this.stocks[stockKey].locationCode = resp.data.data.skus[i].locationCode
                  _this.stocks[stockKey].weight = resp.data.data.skus[i].weight
                  _this.stocks[stockKey].qty = Number(resp.data.data.skus[i].qty)
                  _this.stocks[stockKey].price = Number(resp.data.data.skus[i].retailPrice)
                  _this.stocks[stockKey].costPrice = Number(resp.data.data.skus[i].costPrice)
                  _this.stocks[stockKey].productImageId = resp.data.data.skus[i].productImageId
                  _this.stocks[stockKey].imageSmallUrl = resp.data.data.skus[i].imageSmallUrl

                  if (resp.data.data.productMarkupId.length > 0) {
                    // load pricing into markupCalculationResult
                    _this.stocks[stockKey].markupCalculationResult = {
                      retailPrice: Number(resp.data.data.skus[i].retailPrice),
                      retailQtyPricing: resp.data.data.skus[i].retailQtyPricing,
                      wholesalePrice: Number(resp.data.data.skus[i].wholesalePrice),
                      wholesaleQtyLevel: Number(resp.data.data.skus[i].wholesaleQtyLevel)
                    }
                  } else {
                    // load pricing into retailPricingManual
                    _this.stocks[stockKey].retailPricingManual = resp.data.data.skus[i].retailQtyPricing
                    for (j = 0; j < resp.data.data.skus[i].retailQtyPricing.length; j++) {
                      if (resp.data.data.skus[i].retailQtyPricing[j].qty === Number(resp.data.data.skus[i].wholesaleQtyLevel)) {
                        _this.stocks[stockKey].rdoWholesalePriceLevel = j
                        break
                      }
                    }
                  }

                  // load fixed qty levels
                  fixedQtyText = ''
                  for (k in resp.data.data.skus[i].fixedQtyLevels) {
                    if (fixedQtyText.length > 0) {
                      fixedQtyText = fixedQtyText + ','
                    }
                    fixedQtyText = fixedQtyText + resp.data.data.skus[i].fixedQtyLevels[k]
                  }
                  _this.stocks[stockKey].txtFixedQtyLevels = fixedQtyText
                }
              }
              _this.originalVariantCount = _this.cboVariant

              _this.cboUnavailableCountries = []
              if (resp.data.data.unavailableForCountries) {
                for (i = 0; i < resp.data.data.unavailableForCountries.length; i++) {
                  _this.cboUnavailableCountries.push({
                    countryId: resp.data.data.unavailableForCountries[i].countryId,
                    countryName: resp.data.data.unavailableForCountries[i].countryName
                  })
                }
              }

              _this.productExternalWebsites = resp.data.data.externalWebsites

              _this.getCategories()
              _this.forceUpdate()
            } else {
              console.log('unable to load product details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    getCategories: async function () {
      var _this = this
      return axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            EventBus.$emit('categoryListLoaded', resp.data.data)
            return resp.data.data
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
        })
    },
    getMarkups: function () {
      var _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/markups')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            _this.productMarkups = [{
              caption: 'None',
              value: ''
            }]
            for (var i = 0; i <= resp.data.data.length; i++) {
              _this.productMarkups.push({
                caption: resp.data.data[i].name,
                value: resp.data.data[i].productMarkupId
              })
            }
          } else {
            console.log('unable to load markups: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
        })
    },
    calculateMarkup: function (productMarkupId, costPrice) {
      var _this = this
      console.log('calculateMarkup: ' + productMarkupId + ', ' + costPrice)
      if (productMarkupId.length > 0 && costPrice > 0) {
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + productMarkupId + '/calculate/' + _this.cboCurrencyCode + '/' + costPrice)
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.markupCalculationResult = resp.data.data[0]
            } else {
              console.log('unable to calculate markup: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
            }
          })
      }
    },
    calculateMarkupForVariants: function (productMarkupId) {
      var _this = this
      console.log('calculateMarkupForVariants: ' + productMarkupId)
      if (productMarkupId.length > 0) {
        var i
        var costPricesText = ''
        for (i = 0; i < _this.stocks.length; i++) {
          if (costPricesText.length > 0) {
            costPricesText += ','
          }
          costPricesText += _this.stocks[i].costPrice
        }

        axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + productMarkupId + '/calculate/' + _this.cboCurrencyCode + '/' + costPricesText)
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (i = 0; i < resp.data.data.length; i++) {
                _this.stocks[i].markupCalculationResult = resp.data.data[i]
              }
            } else {
              console.log('unable to calculate markup: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
            }
          })
      }
    },
    getCountries: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/countries?limit=1000')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var countries = []
            for (var i in resp.data.data) {
              countries.push({
                'countryId': resp.data.data[i].countryId,
                'countryName': resp.data.data[i].countryName,
                'isTaxIdCompulsory': resp.data.data[i].isTaxIdCompulsory,
                'taxIdLocalName': resp.data.data[i].taxIdLocalName,
                'isValidateProvince': resp.data.data[i].isValidateProvince,
                'isValidateCity': resp.data.data[i].isValidateCity
              })
            }
            this.countries = countries
          } else {
            console.log('unable to load countries: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              this.$store.dispatch('AUTH_LOGOUT')
              router.push('/me/login?next=' + this.$route.fullPath)
            }
          }
        })
    },
    getSuppliers: function () {
      var _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/suppliers')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            _this.suppliers = _this.suppliers.concat(resp.data.data)
          } else {
            console.log('unable to load suppliers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
        })
    },
    submitProduct: function () {
      var _this = this
      if (_this.$refs.form.validate()) {
        if (_this.images.length > 0) {
          if (_this.cboCategory === _this.cboSecondaryCategory) {
            window.alert('Primary & secondary category must be different')
            return false
          }

          var variantOptions = []
          var i, j, k, l, m, fixedQtyLevels, fixedQtys
          for (i = 0; i < _this.cboVariant; i++) {
            var values = []
            for (j = 0; j < _this.variants[i].options.length; j++) {
              values.push({
                valueCode: _this.variants[i].options[j].id,
                valueName: _this.variants[i].options[j].name,
                orderSequence: j
              })
            }
            variantOptions.push({
              productOptionId: (_this.cboVariant === _this.originalVariantCount ? _this.variants[i].productOptionId : ''),
              optionName: _this.variants[i].variantName,
              values: values,
              orderSequence: i
            })
          }

          var stocksAndPricing = []
          var qtyPricing
          if (_this.cboVariant === 0) {
            if (_this.cboMarkup.length === 0) {
              if (_this.rdoWholesalePriceLevel !== null) {
                qtyPricing = {}
                for (l = 0; l < _this.retailPricingManual.length; l++) {
                  qtyPricing[_this.retailPricingManual[l].qty] = _this.retailPricingManual[l].price
                }
                fixedQtyLevels = []
                fixedQtys = _this.txtFixedQtyLevels.split(',')
                for (m in fixedQtys) {
                  fixedQtyLevels.push(fixedQtys[m].trim())
                }
                stocksAndPricing.push({
                  qty: Number(_this.txtStock),
                  costPrice: Number(_this.txtCostPrice),
                  locationCode: _this.txtLocationCode,
                  weight: Number(_this.txtWeight),
                  retailQtyPricing: qtyPricing,
                  fixedQtyLevels: fixedQtyLevels,
                  wholesaleQtyLevel: (_this.rdoWholesalePriceLevel >= 0 ? _this.retailPricingManual[_this.rdoWholesalePriceLevel].qty : 0)
                })
              } else {
                window.alert('Please specify wholesale level')
                return false
              }
            } else {
              if (Number(_this.txtCostPrice) > 0) {
                stocksAndPricing.push({
                  qty: Number(_this.txtStock),
                  costPrice: Number(_this.txtCostPrice),
                  locationCode: _this.txtLocationCode,
                  weight: Number(_this.txtWeight)
                })
              } else {
                window.alert('Cost price cant be 0')
                return false
              }
            }
          } else {
            for (i = 0; i < _this.stocks.length; i++) {
              // only include the one inside skus list
              for (k = 0; k < _this.skus.length; k++) {
                if (_this.stocks[i].sku === _this.skus[k].sku) {
                  var stockOptions = {}
                  for (j = 0; j < _this.stocks[i].options.length; j++) {
                    stockOptions[_this.stocks[i].options[j].name] = _this.stocks[i].options[j].value
                  }

                  if (_this.cboMarkup.length === 0) {
                    if (_this.stocks[i].rdoWholesalePriceLevel !== null) {
                      qtyPricing = {}
                      for (l = 0; l < _this.stocks[i].retailPricingManual.length; l++) {
                        qtyPricing[_this.stocks[i].retailPricingManual[l].qty] = _this.stocks[i].retailPricingManual[l].price
                      }
                      fixedQtyLevels = []
                      fixedQtys = _this.stocks[i].txtFixedQtyLevels.split(',')
                      for (m in fixedQtys) {
                        fixedQtyLevels.push(fixedQtys[m].trim())
                      }
                      stocksAndPricing.push({
                        options: stockOptions,
                        qty: Number(_this.stocks[i].qty),
                        costPrice: Number(_this.stocks[i].costPrice),
                        locationCode: _this.stocks[i].locationCode,
                        weight: Number(_this.stocks[i].weight),
                        retailQtyPricing: qtyPricing,
                        fixedQtyLevels: fixedQtyLevels,
                        wholesaleQtyLevel: (_this.stocks[i].rdoWholesalePriceLevel >= 0 ? _this.stocks[i].retailPricingManual[_this.stocks[i].rdoWholesalePriceLevel].qty : 0),
                        productImageId: _this.stocks[i].productImageId
                      })
                    } else {
                      window.alert('Please specify wholesale level')
                      return false
                    }
                  } else {
                    if (Number(_this.stocks[i].costPrice) > 0) {
                      stocksAndPricing.push({
                        options: stockOptions,
                        qty: Number(_this.stocks[i].qty),
                        costPrice: Number(_this.stocks[i].costPrice),
                        locationCode: _this.stocks[i].locationCode,
                        weight: Number(_this.stocks[i].weight),
                        productImageId: _this.stocks[i].productImageId
                      })
                    } else {
                      window.alert('Cost price cant be 0')
                      return false
                    }
                  }
                  break
                }
              }
            }
          }

          var params = []
          for (i = 0; i < _this.productParams.length; i++) {
            if (_this.productParams[i].type === 'text') {
              params.push({
                name: _this.productParams[i].name,
                hint: _this.productParams[i].desc,
                type: _this.productParams[i].type,
                textMinLength: _this.productParams[i].param.minLength,
                textMaxLength: _this.productParams[i].param.maxLength,
                textValidationType: _this.productParams[i].param.validationType
              })
            } else if (_this.productParams[i].type === 'file') {
              var extensions = _this.productParams[i].param.extensions.split(',')
              for (j in extensions) {
                extensions[j] = extensions[j].trim()
              }

              params.push({
                name: _this.productParams[i].name,
                hint: _this.productParams[i].desc,
                type: _this.productParams[i].type,
                fileExtensions: extensions
              })
            } else if (_this.productParams[i].type === 'select') {
              params.push({
                name: _this.productParams[i].name,
                hint: _this.productParams[i].desc,
                type: _this.productParams[i].type,
                isMultipleSelection: _this.productParams[i].param.isMultipleSelection,
                selectionItems: _this.productParams[i].param.items,
                productImageId: _this.productParams[i].productImageId
              })
            }
          }

          // inject unavailable countries
          var unavailableForCountries = []
          if (_this.cboUnavailableCountries.length > 0) {
            for (i in _this.cboUnavailableCountries) {
              if (typeof _this.cboUnavailableCountries[i].countryId !== 'undefined') {
                unavailableForCountries.push(_this.cboUnavailableCountries[i].countryId)
              }
            }
          }

          var dataJson = {
            name: _this.txtName,
            keywords: _this.txtKeywords,
            alternativeKeywords: _this.txtAlternativeKeywords,
            currencyCode: _this.cboCurrencyCode,
            categoryId: _this.cboCategory,
            secondaryCategoryIds: ((_this.cboSecondaryCategory) ? [_this.cboSecondaryCategory] : []),
            description: _this.txtDescription,
            metaDescription: _this.txtMetaDescription,
            status: _this.cboStatus,
            isContainLiquid: _this.switchContainLiquid,
            isContainPaste: _this.switchContainPaste,
            isContainBattery: _this.switchContainBattery,
            productMarkupId: _this.cboMarkup,
            supplierId: _this.cboSupplier,
            // isUnlimitedStock: _this.switchUnlimitedStock,
            isVirtualProductAllowBulkPurchase: _this.switchVirtualProductAllowBulkPurchase,
            isSkipServiceProviderSync: _this.switchSkipServiceProviderSync,
            images: _this.images,
            videos: _this.videos,
            params: params,
            options: variantOptions,
            stocksAndPricing: stocksAndPricing,
            unavailableForCountries: unavailableForCountries,
            externalWebsites: _this.productExternalWebsites
          }

          if (_this.productId) {
            // edit product
            _this.loading = true
            axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/' + _this.productId, dataJson, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(resp => {
                console.log(resp.data)
                _this.loading = false
                if (resp.data.status === 'success') {
                  router.push('/products')
                } else {
                  window.alert(resp.data.message)
                }
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.status)
                  if (error.response.status === 401) {
                    router.push('/login?next=' + _this.$route.fullPath)
                  } else if (error.response.status === 403) {
                    _this.showAlert(error)
                  }
                  _this.loading = false
                }
              })
          } else {
            // inject copyProductId if available
            if (_this.copyProductId.length > 0) {
              dataJson.copyProductId = _this.copyProductId
            }

            // create product
            _this.loading = true
            axios.post(process.env.VUE_APP_API_ROOT + '/v1/product', dataJson, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(resp => {
                console.log(resp.data)
                _this.loading = false
                if (resp.data.status === 'success') {
                  router.push('/products')
                } else {
                  window.alert(resp.data.message)
                }
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.status)
                  if (error.response.status === 401) {
                    router.push('/login?next=' + _this.$route.fullPath)
                  } else if (error.response.status === 403) {
                    _this.showAlert(error)
                  }
                  _this.loading = false
                }
              })
          }
        } else {
          window.alert('No image added yet')
        }
      }
    },

    resetImageForm: function () {
      this.imageUploads = []
      this.switchAddWatermark = true
    },
    pickFile: function () {
      this.$refs.image.click()
    },
    onFilePicked: function (e) {
      this.resetImageForm()
      const files = e.target.files
      console.log(files)
      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          // const fr = new FileReader()
          // fr.readAsDataURL(files[i])
          // fr.addEventListener('load', () => {
          //   this.imageUrl = fr.result
          //   this.imageFile = files[i] // this is an image file that can be sent to server...
          // })

          var _this = this
          this.getImageDataAndSetOrientation(files[i], function (imgBase64) {
            _this.imageUploads.push({
              name: files[i].name,
              description: _this.generatePermalink(_this.removeFileExtension(files[i].name)),
              url: imgBase64,
              file: files[i]
            })
          })
        }
      }
    },

    getImageDataAndSetOrientation: function (file, callback2) {
      var callback = function (srcOrientation) {
        var reader2 = new FileReader()
        reader2.onload = function (e) {
          var srcBase64 = e.target.result
          var img = new Image()

          img.onload = function () {
            var width = img.width
            var height = img.height
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')

            // set proper canvas dimensions before transform & export
            if (srcOrientation > 4 && srcOrientation < 9) {
              canvas.width = height
              canvas.height = width
            } else {
              canvas.width = width
              canvas.height = height
            }

            // transform context before drawing image
            switch (srcOrientation) {
              case 2: ctx.transform(-1, 0, 0, 1, width, 0); break
              case 3: ctx.transform(-1, 0, 0, -1, width, height); break
              case 4: ctx.transform(1, 0, 0, -1, 0, height); break
              case 5: ctx.transform(0, 1, 1, 0, 0, 0); break
              case 6: ctx.transform(0, 1, -1, 0, height, 0); break
              case 7: ctx.transform(0, -1, -1, 0, height, width); break
              case 8: ctx.transform(0, -1, 1, 0, 0, width); break
              default: break
            }

            // draw image
            ctx.drawImage(img, 0, 0)

            // export base64
            callback2(canvas.toDataURL())
          }

          img.src = srcBase64
        }

        reader2.readAsDataURL(file)
      }

      var reader = new FileReader()
      reader.onload = function (e) {
        var view = new DataView(e.target.result)
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2)
        }
        var length = view.byteLength
        var offset = 2
        while (offset < length) {
          var marker = view.getUint16(offset, false)
          offset += 2
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1)
            var little = view.getUint16(offset += 6, false) === 0x4949
            offset += view.getUint32(offset + 4, little)
            var tags = view.getUint16(offset, little)
            offset += 2
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                return callback(view.getUint16(offset + (i * 12) + 8, little))
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break
          } else {
            offset += view.getUint16(offset, false)
          }
        }
        return callback(-1)
      }
      reader.readAsArrayBuffer(file)
    },

    submitImage () {
      var _this = this
      if (_this.$refs.formImage.validate()) {
        _this.loading = true
        var formData = new FormData()
        // dont set product id yet, bcos product not saved yet
        // if (_this.productId) {
        //   formData.append('productId', _this.productId)
        // }
        formData.append('isWatermark', (_this.switchAddWatermark ? 'true' : 'false'))
        for (var i in _this.imageUploads) {
          formData.append('imageFile' + (parseInt(i) + 1), _this.imageUploads[i].file, _this.imageUploads[i].name)
          formData.append('description' + (parseInt(i) + 1), _this.imageUploads[i].description)
        }
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(resp => {
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              var errorText = ''
              for (var j in resp.data.data) {
                if (typeof resp.data.data[j].error === 'undefined') {
                  _this.images = _this.images.concat(resp.data.data[j])
                } else {
                  if (errorText !== '') {
                    errorText = errorText + '\r\n'
                  }
                  errorText = errorText + resp.data.data[j].error
                }
              }
              _this.dialogAddImage = false
              if (errorText !== '') {
                window.alert(errorText)
              }
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    }

  }
}
</script>
